import React from 'react';
import Skeleton from 'react-loading-skeleton';

import useTranslation from '../../../../hooks/useTranslation';

import '../AccountTransactionNotificationSettings.scss';

const AccountTransactionNotificationSettingsSkeleton: React.FC = () => {
    const { pushNotifications: pushNotificationTexts } = useTranslation();
    return (
        <section className="account-transaction-notification-settings">
            <div className="account-transaction-notification-settings__intro-section">
                <span className="semibold">{pushNotificationTexts.account.customNotifications}</span>
                <ul className="account-transaction-notification-settings__active-toggle-list" />
            </div>
            <div className="account-transaction-notification-settings__collapsable-section--skeleton">
                <Skeleton height={52} width="100%" />
            </div>
        </section>
    );
};

export default AccountTransactionNotificationSettingsSkeleton;
